















































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import BpcFooter from '@shared/layouts/components/footer/footer.vue';
import BpcHeader from '@shared/layouts/components/header/header.vue';

@Component({
  name: 'bpc-pos-page-container',
  components: {
    BpcHeader,
    BpcFooter,
  },
})
export default class PosPageContainer extends Vue {
  // PROPS
  @Prop({ type: Boolean }) readonly topRightLargePanel: boolean = false;

  // DATA

  // COMPUTED

  // LIFECYCLE HOOKS

  // METHODS
}
